// extracted by mini-css-extract-plugin
module.exports = {"actions":"_29WxCMbNiSqrizsrv9R94h","bottom":"_2PVoY459vHSsmOgAa5l16S"};